import { useEffect, useRef } from 'react'

// Keeps a ref pointing at the latest value across renders, so an effect can
// read it without needing to depend on it (avoiding a re-run/re-subscribe
// every time the value's identity changes, e.g. an inline callback prop or a
// function redefined every render).
function useLatest(value) {
  const ref = useRef(value)

  useEffect(() => {
    ref.current = value
  })

  return ref
}

export default useLatest
